exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.pagination li[data-v-7a74f1c7] {\n\tdisplay: inline-block;\n}\n.pagination a[data-v-7a74f1c7] {\n\tmin-width: 4ex;\n\ttext-align: center;\n}\n", ""]);
